import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { CiGlobe } from 'react-icons/ci';
import './DinamicTableDetail.css';

const DinamicTableDetail = ({ data, modalDetail }) => {
    if (!data || !data.dimensionHeaders || !data.metricHeaders || !data.rows) {
        return null;
    }

    const styleButton = {
        background: '#f3f3f3',
        outline: 'none',
        cursor: 'pointer',
        padding: 4,
        display: 'inline-flex',
        border: 'none',
        borderRadius: '50%',
        boxShadow: '1px 1px 2px 0px rgb(0 0 0 / .3)',
    };

    return (
        <div style={{ width: '80%', borderColor: 'lightgreen' }}>
            <Table size="sm" striped bordered hover>
                <thead>
                    <tr>
                        <th>Detail</th>
                        <th className="fixed-width-cell">PathName</th>
                        <th>Views</th>
                        <th>Path</th>
                    </tr>
                </thead>
                <tbody>
                    {data.rows.map((row, index) => (
                        <tr key={index}>
                            <td>
                                <Button
                                    size="sm"
                                    type="button"
                                    className="btn btn-success"
                                    alt="Detail"
                                    onClick={() => {
                                        modalDetail(0, row.dimensionValues[0].value);
                                    }}
                                >
                                    View
                                </Button>
                            </td>

                            {row.dimensionValues.map((dimension, dimensionIndex) => (
                                <td className="fixed-width-cell" key={`dimension-${index}-${dimensionIndex}`}> {dimension.value} </td>
                            ))}
                            {row.metricValues.map((metric, metricIndex) => (
                                <td key={`metric-${index}-${metricIndex}`}>{metric.value}</td>
                            ))}

                            <td align="center">
                                <button
                                    title={row.dimensionValues[0].value}
                                    style={styleButton}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        window.open('https://' + row.dimensionValues[0].value, '_blank', 'noreferrer');
                                    }}
                                >
                                    <CiGlobe color="blue" />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
};

export default DinamicTableDetail;